export default __webpack_public_path__ + "static/media/clip-order-completed-2.1d12217a.png";